import { API_URL_BASE, htmlElem, contentElem } from '../utils/globals';
import { setAjaxLoading, setAjaxComplete } from '../utils/ajaxLoaders';
import { retrieveFromSessionStorage } from '../utils/utilsStorage';
import { removeChildNodes } from '../utils/removeChildNodes';
import { resetEmptyBlogItems } from '../utils/resetEmptyBlogItems';
import { updatePushState } from '../utils/updatePushState';

const fetchLinkedPage = () => {
    const slug = retrieveFromSessionStorage('pageId');
    if (slug) {
        fetch(`${API_URL_BASE}/pages?slug=${slug}`)
            .then((response) => response.json())
            .then((data) => {
                if (!data.length) {
                    return;
                }
                setAjaxLoading(htmlElem);
                removeChildNodes(contentElem);
                const template = `<p>${data[0].content.rendered}</p>`;
                contentElem.insertAdjacentHTML('beforeend', template);
                updatePushState(slug);
            })
            .catch(err => console.log(err))
            .finally(() => {
                resetEmptyBlogItems();
                setAjaxComplete(htmlElem);
                sessionStorage.removeItem('pageId');
            });
        }
}

export {
    fetchLinkedPage
}